module.exports = __webpack_public_path__ + "img/apexlegends-cover.7be1f458.jpg";